// Sitewide behavior: mobile nav toggle, "Shop by Goal" dropdown, scroll reveal.
document.addEventListener("DOMContentLoaded", function () {
  var navToggle = document.querySelector(".nav-toggle");
  var mobileNav = document.querySelector(".mobile-nav");
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", function () {
      mobileNav.classList.toggle("open");
    });
  }

  document.querySelectorAll(".main-nav .has-dropdown").forEach(function (dropdown) {
    var trigger = dropdown.querySelector(":scope > a");
    if (!trigger) return;
    trigger.addEventListener("click", function (event) {
      if (window.matchMedia("(hover: hover)").matches) return;
      event.preventDefault();
      var isOpen = dropdown.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", String(isOpen));
    });
  });
  document.addEventListener("click", function (event) {
    document.querySelectorAll(".main-nav .has-dropdown.is-open").forEach(function (dropdown) {
      if (!dropdown.contains(event.target)) {
        dropdown.classList.remove("is-open");
        var trigger = dropdown.querySelector(":scope > a");
        if (trigger) trigger.setAttribute("aria-expanded", "false");
      }
    });
  });
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".main-nav .has-dropdown.is-open").forEach(function (dropdown) {
      dropdown.classList.remove("is-open");
      var trigger = dropdown.querySelector(":scope > a");
      if (trigger) { trigger.setAttribute("aria-expanded", "false"); trigger.focus(); }
    });
  });

  var revealEls = document.querySelectorAll(".reveal");
  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("in");
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function (el) { revealObserver.observe(el); });
  }
});
